<div id="content">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="page-title">
          <h1>{{ page_title }}</h1>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="bisual-table">
          <form class="card paginator" [formGroup]="filterForm">
            <mat-paginator
              [length]="length"
              [pageSize]="pageSize"
              [pageSizeOptions]="pageSizeOptions"
              [pageIndex]="pageIndex"
              (page)="changePage($event)"
              style="margin-right: auto"
            ></mat-paginator>
            @if (is_rrhh_or_admin()) {
              <mat-form-field style="margin-right: 10px; min-width: 150px">
                <mat-label>Responsable</mat-label>
                <mat-select formControlName="responsible_user_id">
                  <mat-option [value]="''">Todas</mat-option>
                  <mat-option [value]="currentUserId">Las que gestiono yo</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field style="margin-right: 10px; min-width: 150px">
                <mat-label>Estado</mat-label>
                <mat-select formControlName="status">
                  <mat-option [value]="''">Todos</mat-option>
                  <mat-option [value]="EmployeeRequestResponsibleForAnswerStatusEnum.PENDING">Pendiente</mat-option>
                  <mat-option [value]="EmployeeRequestResponsibleForAnswerStatusEnum.ACCEPTED">Aceptada</mat-option>
                  <mat-option [value]="EmployeeRequestResponsibleForAnswerStatusEnum.REJECTED">Rechazada</mat-option>
                </mat-select>
              </mat-form-field>
            }
          </form>

          <div class="bisual-table-container">
            <table mat-table [dataSource]="dataSource">
              <!-- User Column -->
              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef>Usuario</th>
                <td mat-cell *matCellDef="let element">{{ element.user?.full_name }}</td>
              </ng-container>

              <!-- Start Date Column -->
              <ng-container matColumnDef="start_date">
                <th mat-header-cell *matHeaderCellDef>Inicio</th>
                <td mat-cell *matCellDef="let element">{{ element.start_date | date: 'dd/MM/yyyy' }}</td>
              </ng-container>

              <!-- End Date Column -->
              <ng-container matColumnDef="end_date">
                <th mat-header-cell *matHeaderCellDef>Fin</th>
                <td mat-cell *matCellDef="let element">{{ element.end_date | date: 'dd/MM/yyyy' }}</td>
              </ng-container>

              <!-- Max Weekly Hours Column -->
              <ng-container matColumnDef="max_weekly_hours">
                <th mat-header-cell *matHeaderCellDef>Max. Horas</th>
                <td mat-cell *matCellDef="let element">{{ element.max_weekly_hours || '-' }}</td>
              </ng-container>

              <!-- CompanyProducts Column -->
              <ng-container matColumnDef="company_product">
                <th mat-header-cell *matHeaderCellDef>Productos</th>
                <td mat-cell *matCellDef="let element">{{ formatCompanyProducts(element) }}</td>
              </ng-container>

              <!-- Justification Column -->
              <ng-container matColumnDef="justification">
                <th mat-header-cell *matHeaderCellDef>Justificación</th>
                <td mat-cell *matCellDef="let element">
                  <span [matTooltip]="element.justification" class="truncate max-w-xs block">
                    {{ element.justification }}
                  </span>
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element">
                  <span [class]="'status-badge status-' + element.status">
                    {{ getStatusLabel(element.status) }}
                  </span>
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>

                <td mat-cell *matCellDef="let element">
                  <div class="actions-cell">
                    <button mat-icon-button (click)="openApprovalStatusDialog(element)" matTooltip="Estado de aprobación">
                      <mat-icon>info</mat-icon>
                    </button>
                    @if (element.status === EmployeeRequestResponsibleForAnswerStatusEnum.PENDING) {
                      <button mat-icon-button color="accent" (click)="accept(element.id)" matTooltip="Aceptar">
                        <mat-icon>check_circle</mat-icon>
                      </button>
                      <button mat-icon-button color="warn" (click)="reject(element.id)" matTooltip="Rechazar">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    }
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
